import { forwardRef } from "react";
import { string } from "prop-types";
import { observer } from "mobx-react";
import { CELL_WIDTHS, TABLE_DRAGGABLE_CONTAINER } from "@utils";
import {
  usePresetFieldNames,
  useEstimateStructure,
  useEstimateEditorSettings,
  useEstimateTableSettings,
  HeaderRow,
  PinnableCell, ExpandContainer
} from "@tools";
import { SortableListV2 } from "@components";
import Grid from "@material-ui/core/Grid";
import { HeaderColumnFactory } from "./HeaderColumnFactory";
import classnames from "classnames";

export const TableHeader = observer(forwardRef(({ tableIdentifier }, ref) => {
  const {
    allowEdition,
    isProposal,
    useProfitability,
  } = useEstimateEditorSettings();
  const { columns, useExpandCell } = useEstimateTableSettings();
  const { settings } = useEstimateStructure();
  const { getFieldName } = usePresetFieldNames(isProposal);
  // const { settings } = structure;
  
  // const handleOpenAction = () => {
  //   structure.expandAllWorkTypes();
  // };

  const handleColumnReorder = (list) => {
    settings.reorderSummaryColumns(list);
  };
  
  return (
    <HeaderRow
      ref={ref}
      id={tableIdentifier}
      className="tableHeaderContainer preset-paper"
      actionPresetClass="preset-paper"
    >
      <PinnableCell
        // allowOverflowDisplay
        minWidth={useProfitability ? CELL_WIDTHS.TITLE_SUMMARY_EMPTY : CELL_WIDTHS.TITLE_SUMMARY}
        pinnedLeft
        isHeader
        containers={
          useExpandCell &&
          <ExpandContainer isHeader />
        }
      >
        <span className="preset-tableSummaryHeader pt-work">
          {getFieldName("pt-work")}
        </span>
      </PinnableCell>
      <Grid
        className={classnames(TABLE_DRAGGABLE_CONTAINER, "cell")}
        item
        container
        wrap="nowrap"
        alignItems="center"
        style={{ width: "initial" }}
      >
        <SortableListV2
          list={columns}
          group="summary-columns"
          itemIdKey="name"
          childIdKey="columnName"
          onListReorder={handleColumnReorder}
          disabled={!allowEdition || useProfitability}
          lockAxis
        >
          {columns.map(({ name }, index) => (
            <HeaderColumnFactory
              key={name}
              columnName={name}
              extendPadding={index === columns.length-1}
            />
          ))}
        </SortableListV2>
      </Grid>
    </HeaderRow>
  );
}));

TableHeader.propTypes = {
  tableIdentifier: string,
};
